import { render, staticRenderFns } from "./ProductCatalogHome.vue?vue&type=template&id=1a396bb9"
import script from "./ProductCatalogHome.vue?vue&type=script&lang=js"
export * from "./ProductCatalogHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports